import React from 'react'
import "./automationScheduleAndAlert.scss"

//Imagens:
import imgScheduling from "../../../../assets/scheduling/imgScheduling.png"
import { useTranslation } from 'react-i18next'

function AutomationScheduleAndAlert() {
  const {t} = useTranslation()

  return (
    <div className='container-section-automationScheduleAndAlert'>
        <div className="img-section-automationScheduleAndAlert">
            <img src={imgScheduling} alt="imagem publique e compartilhe" />
        </div>
        <div className="texts-section-automationScheduleAndAlert">
            <h1>{t("scheduling.title")}</h1>
            <p>{t("scheduling.section_text")}</p>
            <a href="/form">
                <button id='btn-section-automationScheduleAndAlert'>{t("buttons.demo_btn_alternative_text_1")}</button>
            </a>
        </div>
    </div>
  )
}

export default AutomationScheduleAndAlert